import React from "react";
import PropTypes from "prop-types";

function UserIcon({ width, height, viewBox = "" }) {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox={viewBox}>
      <path
        d="M16 18H0c0-4.519 3.582-8.182 8-8.182s8 3.663 8 8.182zM7.6 9C5.17 9 3.2 6.985 3.2 4.5S5.17 0 7.6 0C10.03 0 12 2.015 12 4.5S10.03 9 7.6 9z"
        fill="currentColor"
      />
    </svg>
  );
}
UserIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string
};

export { UserIcon };
